import script from "./MemberBenefits.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberBenefits.vue?vue&type=script&setup=true&lang=js"

import "./MemberBenefits.vue?vue&type=style&index=0&id=14bf006a&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14bf006a"]])

export default __exports__